import request from '../../request'

export default {
  actions: {
    
    createApplication(_, payload) {
      return request.post('application', payload)
    },
    getApplication(_, payload) {
      return request.get('get-application', payload)
    },
    getApplicationById(_, payload) {
      return request.get('get-application/', payload)
    },
    deleteApplication(_, id) {
      return request.delete('get-application/' + id)
    },

  }
}
